import { makeStyles } from '@rbx/ui';

const useCharacteristicsTableContainerStyles = makeStyles<void, 'contentGroup'>()(
  (theme, _, { contentGroup }) => ({
    root: {
      [`& > ${contentGroup}`]: {
        marginBottom: theme.spacing(3),
        '&:not(:first-child)': {
          marginTop: theme.spacing(6),
        },
      },
    },

    contentGroup: {},

    ownCharacteristic: {
      [theme.breakpoints.down('Medium')]: {
        overflowX: 'auto',
      },
    },

    sectionHeader: {
      marginBottom: theme.spacing(3),
    },

    members: {
      marginBottom: theme.spacing(6),
    },

    accordionGrid: {
      marginTop: 12,
      marginBottom: 12,
      '&:last-child': {
        marginBottom: 0,
      },
    },

    inheritedMembers: {
      marginTop: theme.spacing(3),
    },

    accordion: {
      width: '100%',
    },

    instanceLink: {
      paddingLeft: '0',
    },
  }),
);

export default useCharacteristicsTableContainerStyles;
